import { createContext, Dispatch, SetStateAction } from "react";

export type QuestionnaireType = {
	clarity: number;
	confidence: number;
	selfKnowledge: number;
	anxiety: number;
};

export interface IRegistrationContext
{
	setStep: Dispatch<SetStateAction<number>>;

	name: string;
	setName: Dispatch<SetStateAction<string>>;

	email: string;
	setEmail: Dispatch<SetStateAction<string>>;

	before: QuestionnaireType;
	setBefore: Dispatch<SetStateAction<QuestionnaireType>>;
}

export const RegistrationCtx = createContext<IRegistrationContext>({} as IRegistrationContext);
